export enum SortedBy {
  TIME = 'time',
  PROPERTY = 'property',
  ASSIGNEE = 'assignee',
  NAME = 'item.name:asc',
  SKU = 'item.sku:asc',
  LOCATION = 'location.name:asc',
}

export type SortableJob = {
  scheduledStartDate?: string | null;
  scheduledStartTime?: string | null;
  location?: { name?: string | null } | null;
  assignees?: Array<{ name?: string | null } | null> | null;
};

export function sortJobs<T>(sortBy: SortedBy, jobs?: readonly T[] | null): T[] {
  if (!jobs) return [];

  const jobsGroupedByDate = jobs.reduce((groups, job) => {
    const sortable = job as SortableJob;
    const date = sortable.scheduledStartDate as string;
    if (!groups[date]) {
      groups[date] = [];
    }
    groups[date].push(job);
    return groups;
  }, {} as Record<string, T[]>);

  const sortedGroups = Object.entries(jobsGroupedByDate).map(([, jobsList]) => {
    let sortedJobs: T[];

    switch (sortBy) {
      case SortedBy.TIME:
        sortedJobs = jobsList.sort((a, b) => {
          const timeA = (a as SortableJob).scheduledStartTime ?? '';
          const timeB = (b as SortableJob).scheduledStartTime ?? '';
          return timeA.localeCompare(timeB);
        });
        break;
      case SortedBy.PROPERTY:
        sortedJobs = jobsList.sort((a, b) => {
          const locationA = (a as SortableJob).location?.name ?? '';
          const locationB = (b as SortableJob).location?.name ?? '';
          return locationA.localeCompare(locationB);
        });
        break;
      case SortedBy.ASSIGNEE:
        sortedJobs = jobsList.sort((a, b) => {
          const assigneeA = (a as SortableJob).assignees?.[0]?.name ?? '';
          const assigneeB = (b as SortableJob).assignees?.[0]?.name ?? '';
          return assigneeA.localeCompare(assigneeB);
        });
        break;
      default:
        sortedJobs = jobsList;
    }

    return sortedJobs;
  });

  return sortedGroups.flat();
}
